import React from "react";
import Card from "react-bootstrap/Card";
import 'animate.css/animate.min.css';
import './Serv.css'; // Create this CSS file for custom styles

const languages = [
  {
    name: "MERN Stack",
    logo: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
    description: "MongoDB, Express, React, Node.js ",
  },
  {
    name: "PERN Stack",
    logo: "https://cdn.worldvectorlogo.com/logos/postgresql.svg",
    description: "PostgreSQL, Express, React, Node.js ",
  },
  {
    name: "React.js",
    logo: "https://cdn.worldvectorlogo.com/logos/react-2.svg",
    description: "UI development for web app",
  },
  {
    name: "Flutter",
    logo: "https://cdn.worldvectorlogo.com/logos/flutter.svg",
    description: "Cross-platform mobile apps ",
  },
  {
    name: "Firebase",
    logo: "https://cdn.worldvectorlogo.com/logos/firebase-1.svg",
    description: " Backend, authentication ",
  },
  {
    name: "Node.js",
    logo: "https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg",
    description: " Server-side JavaScript ",
  },
  {
    name: "Express.js",
    logo: "https://cdn.worldvectorlogo.com/logos/express-109.svg",
    description: "Minimalist backend ",
  },
  {
    name: "MongoDB",
    logo: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
    description: "NoSQL database for",
  },
  {
    name: "PostgreSQL",
    logo: "https://cdn.worldvectorlogo.com/logos/postgresql.svg",
    description: "Advanced open-source ",
  },
  {
    name: "Dart",
    logo: "https://cdn.worldvectorlogo.com/logos/dart.svg",
    description: "Flutter apps",
  },
  {
    name: "Cloudinary",
    logo: "https://res.cloudinary.com/cloudinary-marketing/image/upload/v1641411394/website/Cloudinary_logo_for_white_bg.svg",
    description: "Media storage",
  },
  {
    name: "Dialogflow",
    logo: "https://cdn.worldvectorlogo.com/logos/dialogflow-2.svg",
    description: "Conversational",
  },
  {
    name: "Git",
    logo: "https://cdn.worldvectorlogo.com/logos/git-icon.svg",
    description: "Version control",
  },
  {
    name: "GitHub",
    logo: "https://cdn.worldvectorlogo.com/logos/github-icon-1.svg",
    description: "Cloud hosting for ",
  },
  {
    name: "JavaScript",
    logo: "https://cdn.worldvectorlogo.com/logos/logo-javascript.svg",
    description: "Core scripting ",
  },
  {
    name: "HTML5",
    logo: "https://cdn.worldvectorlogo.com/logos/html5.svg",
    description: "Markup for ",
  },
  {
    name: "CSS3",
    logo: "https://cdn.worldvectorlogo.com/logos/css3.svg",
    description: "Styling the web ",
  }
];

function Serv() {
  return (
    
    <div className="my-3 tech-stack-wrapper">
    
      <div className="tech-scroll-container">
        <div className="tech-scroll-content">
          {[...languages, ...languages].map((lang, idx) => (
            <Card
              key={idx}
              className="d-flex flex-row align-items-center shadow-sm tech-card"
            >
              <div className="tech-logo-container">
                <img
                  src={lang.logo}
                  alt={lang.name}
                  className="tech-logo"
                />
              </div>
              <div className="tech-text">
                <h6 className="fw-bold mb-1">{lang.name}</h6>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Serv;
